import { Link } from 'react-router-dom';

export default function IndustriesCTA() {
  return (
    <section className="bg-amber-500 py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0F172A] mb-6 leading-tight">
          Your Industry Has a System—
          <br />We Optimize It.
        </h2>
        <p className="text-[#0F172A]/70 text-lg leading-relaxed mb-10 max-w-xl mx-auto">
          Every business we work with gets a custom automation audit before we build
          anything. We map your specific workflow and identify every revenue leak before
          day one.
        </p>
        <Link
          to="/services"
          className="whitespace-nowrap inline-block bg-[#0F172A] text-white font-bold text-base px-12 py-4 rounded-lg hover:bg-slate-800 transition-colors cursor-pointer"
        >
          Start Your Automation Audit
        </Link>
      </div>
    </section>
  );
}
